$(document).ready(function () {

    if ($('.luka__carousel').length) {
        $('.luka__carousel').on('init', function (event, slick) {
            $('.luka__carousel').append('<div class="slider-count bien__number"><p><span id="current">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.luka__carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            // autoplay: true,
            autoplaySpeed: 7000,
            arrows: false,
            dots: true,
        });
        $('.luka__carousel')
            .on('afterChange', function (event, slick, currentSlide) {
                // finally let do this after changing slides
                $('.slider-count #current').html(currentSlide + 1);
            });
    }

    if ($('.luka__carousel2')) {
        $('.luka__carousel2').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.luka__carousel3'
        });
    }

    if ($('.luka__carousel3')) {
        $('.luka__carousel3').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.luka__carousel2',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false
        });
    }

    // let buttonCountPlus = document.getElementById("buttonCountPlus");
    // let buttonCountMinus = document.getElementById("buttonCountMinus");
    // let count = document.getElementById("buttonCountNumber");
    // let number = 1;
    // buttonCountPlus.onclick = function () {
    //     if (number <= 100) {
    //         number++;
    //         count.innerHTML = number;
    //     }
    // };
    // buttonCountMinus.onclick = function () {
    //     if (number >= 1) {
    //         number--;
    //         count.innerHTML = number;
    //     }
    // };
});
